const normalizeClientSearch = (value) => {
  if (typeof value !== 'string') {
    return ''
  }

  return value.trim().toLowerCase()
}

export const hasClientSearch = (searchTerm) => normalizeClientSearch(searchTerm) !== ''

export const filterClientNamesBySearch = (clientNames, searchTerm) => {
  const normalizedSearch = normalizeClientSearch(searchTerm)

  if (!normalizedSearch) {
    return clientNames
  }

  return clientNames.filter((clientName) => normalizeClientSearch(clientName).includes(normalizedSearch))
}
